import { useState, useEffect } from 'react';
import { getGameProgress, saveGameProgress, stageCosts } from '../utils/storage';
import styles from './HouseBuildingPage.module.css';

const HouseBuildingPage = () => {
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    const fetchProgress = async () => {
      const gameProgress = await getGameProgress();
      setProgress(gameProgress);
    };
    fetchProgress();
  }, []);

  useEffect(() => {
    if (!progress) return;
    const canvas = document.getElementById('house-canvas');
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (progress.houseStages >= 1) {
      ctx.fillStyle = 'brown';
      ctx.fillRect(50, 150, 200, 50); // Foundation
    }
    if (progress.houseStages >= 2) {
      ctx.fillStyle = 'orange';
      ctx.fillRect(50, 100, 200, 50); // Walls
    }
    if (progress.houseStages >= 3) {
      ctx.beginPath();
      ctx.moveTo(50, 100);
      ctx.lineTo(150, 50);
      ctx.lineTo(250, 100);
      ctx.closePath();
      ctx.fillStyle = 'red';
      ctx.fill(); // Roof
    }
  }, [progress]);

  const buildNextStage = async () => {
    if (!progress) return;
    const nextStage = progress.houseStages + 1;
    const cost = stageCosts[nextStage - 1];
    if (progress.bricks >= cost) {
      const newProgress = { ...progress, bricks: progress.bricks - cost, houseStages: nextStage };
      await saveGameProgress(newProgress);
      setProgress(newProgress);
    }
  };

  if (!progress) return <div>Loading...</div>;

  const nextCost = stageCosts[progress.houseStages] || 'Complete';

  return (
    <div className={styles.container}>
      <h1>Orange Dynasty House</h1>
      <canvas id="house-canvas" width="300" height="200" />
      <p>Bricks Available: {progress.bricks}</p>
      <p>Next Stage Cost: {nextCost}</p>
      {nextCost !== 'Complete' && (
        <button onClick={buildNextStage} disabled={progress.bricks < nextCost}>
          Build Next Stage
        </button>
      )}
    </div>
  );
};

export default HouseBuildingPage;